module.exports = __webpack_public_path__ + "img/mtc-detail.9292df3f.webp";